import MentoringModal from './MentoringModal.vue';

export * from './components';
export default MentoringModal;



// WEBPACK FOOTER //
// ./src/pages/profile/modules/mentoring/modal/index.ts